module.exports = __webpack_public_path__ + "static/media/unmute.5667bac5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/unmute.svg
// module id = 89
// module chunks = 0